import { Component, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Resource } from '../../../../../services/api/ftth-resource/ftth-resource.service';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-spec-table',
  template: '',
})
export abstract class SpecTableComponent {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input()
  set resources(value: Resource[]) {
    this.tableDataSource.data = value ? value : [];
  }

  tableDataSource: MatTableDataSource<Resource> = new MatTableDataSource<Resource>([]);
  displayedColumns: string[] = [];
  pageSizeOptions = [10, 20, 50];
  showFirstLastButtons = true;
  pageSize = 20;

  protected constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
  }

  onInit() {
    this.tableDataSource.paginator = this.paginator;
    this.tableDataSource.sort = this.sort;
  }

  navigateToDetail(resource: Resource) {
    const hrefLinkChunks = resource._links.self.href.split('/');
    this.router.navigate(['..', btoa(hrefLinkChunks[hrefLinkChunks.length - 1])], { relativeTo: this.activatedRoute });
  }

}
